export default {
      id: "unit-list-temp-usage",
      viewBox: "0 0 19 20",
      url: __webpack_public_path__ + "img/icons.svg#unit-list-temp",
      toString: function () {
        return this.url;
      }
    }